import React from 'react';

interface PeoplesIconProps {
  className?: string;
}

const PeoplesIcon: React.FC<PeoplesIconProps> = ({ className }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M16.3039 3.5C17.3203 4.11245 18 5.22685 18 6.5C18 7.77315 17.3203 8.88755 16.3039 9.5M22 21V20.4C22 18.1598 21.9999 17.0397 21.564 16.1841C21.1805 15.4314 20.5686 14.8196 19.8159 14.4361M9.5 10C11.433 10 13 8.433 13 6.5C13 4.56701 11.433 3 9.5 3C7.567 3 6 4.56701 6 6.5C6 8.433 7.567 10 9.5 10ZM2 20.4V21H17V20.4C17 18.1598 17 17.0397 16.5641 16.184C16.1806 15.4314 15.5686 14.8195 14.816 14.436C13.9603 14 12.8402 14 10.6 14H8.4C6.1598 14 5.0397 14 4.18404 14.436C3.43139 14.8195 2.81947 15.4314 2.43598 16.184C2 17.0397 2 18.1598 2 20.4Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default PeoplesIcon;